// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3YE6S","col":"styles_col__3zH-f"};